import React, { FC, useEffect, useState } from 'react';
import _ from 'lodash';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import type { QueryParams } from '@common/types';
import ControlledRadioGroup from './ControlledRadioGroup';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';

type Props = {
  selectedValue: string | undefined;
  items: Record<string, string>;
  langTokenPrefix: string;
  createUpdatedQueryParam: (selectedItem: string | undefined) => QueryParams;
  dataHook: string;
};

const OneSelectionFilter: FC<Props> = ({
  selectedValue,
  items,
  langTokenPrefix,
  createUpdatedQueryParam,
  dataHook,
}) => {
  const [selected, setSelected] = useState<keyof typeof items | undefined>(
    selectedValue,
  );

  useEffect(() => {
    setSelected(selectedValue);
  }, [selectedValue]);

  const { navigate, router } = useShallowRouter();
  const { logBiClick } = useTemplatesBi({ is_mobile: false });

  const onChange = (val?: string | number) => {
    logBiClick({
      click_type: 'mark filter',
      click_data: { filter_name: `${dataHook}-${val}` },
    });
    const selectedItem =
      val === 'ALL' ? undefined : (val as keyof typeof items);
    setSelected(val as keyof typeof items);
    navigate(updateQueryParams(createUpdatedQueryParam(selectedItem), router));
  };

  return (
    <ControlledRadioGroup
      selected={selected}
      onChange={onChange}
      items={items}
      langTokenPrefix={langTokenPrefix}
      textSize="small"
    />
  );
};

export default OneSelectionFilter;
